import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthGuard} from "./core/guards/AuthGuard";
import {TestPageComponent} from "./pages/test-page/test-page.component";

export const routes: Routes = [
  {
    path: 'auth',
    data: { breadcrumb: 'Authentication' },
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'error',
    data: { breadcrumb: 'Error' },
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: 'supplier-upload/:token',
    loadChildren: () =>
      import('./pages/supplier-upload/supplier-upload.module').then((m) => m.SupplierUploadModule),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./_metronic/layout/layout.module').then((m) => m.LayoutModule),
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
